import { useEffect } from "react";
import { ApiError, get as apiGet } from "@/api/client";
import { useAuth } from "@/stores/auth";

const MOCK_MODE = import.meta.env.VITE_AUTH_MOCK === "true";
const AUTH_CHECK_INTERVAL_MS = 60_000;

export function AuthSessionWatcher() {
  const status = useAuth((state) => state.status);
  const user = useAuth((state) => state.user);
  const sessionExpiryNotice = useAuth((state) => state.sessionExpiryNotice);
  const beginSessionExpiry = useAuth((state) => state.beginSessionExpiry);

  useEffect(() => {
    if (MOCK_MODE || status !== "ready" || !user || sessionExpiryNotice) {
      return;
    }

    let cancelled = false;
    let visible = !document.hidden;

    const tick = async () => {
      if (cancelled || !visible) return;

      try {
        await apiGet("/auth/me");
      } catch (error) {
        if (cancelled) return;
        if (error instanceof ApiError && error.status === 401) {
          beginSessionExpiry("Your session expired. Redirecting to logout in 10 seconds.");
        }
      }
    };

    void tick();
    const intervalId = window.setInterval(() => {
      void tick();
    }, AUTH_CHECK_INTERVAL_MS);
    const handleVisibilityChange = () => {
      visible = !document.hidden;
    };
    document.addEventListener("visibilitychange", handleVisibilityChange);

    return () => {
      cancelled = true;
      window.clearInterval(intervalId);
      document.removeEventListener("visibilitychange", handleVisibilityChange);
    };
  }, [beginSessionExpiry, sessionExpiryNotice, status, user]);

  return null;
}
